import {locale} from '@gl/locale';
import {audienceBuilderLang} from '@gl/locale/translations/audiences/builder.js';
import {
  AbortedRequestError,
  DuplicatedRequestError,
} from '@gl/lit/lib/http_service/errors.js';
import type {FlyErrorPart} from '@gl/lit/utils/errors.js';
import {FlyErrorConcern} from '@gl/lit/utils/errors.js';

const lang = audienceBuilderLang[locale.current];

export class InvalidEndpointError extends FlyErrorConcern {
  static errorName = 'InvalidEndpointError';
  name = 'InvalidEndpointError';

  constructor(message = 'Endpoint does not exist', parts: FlyErrorPart[] = []) {
    super(message, ...parts);
  }
}

export class AudienceNameConflictError extends FlyErrorConcern {
  static errorName = 'AudienceNameConflictError';
  name = 'AudienceNameConflictError';

  constructor(
    message = lang.name.error.taken.message,
    parts: FlyErrorPart[] = []
  ) {
    super(message, ...parts);
  }
}

export type RequestManagerError =
  | AbortedRequestError
  | DuplicatedRequestError
  | InvalidEndpointError
  | AudienceNameConflictError;

export {AbortedRequestError, DuplicatedRequestError};
